import React from "react"
import styled from "styled-components"
import LazyLoad from "react-lazyload"

const Wrapper = styled.div`
  background-color: #fafafa;
  height: 0;
  padding-bottom: 56.25%;
  position: relative;
  overflow: hidden;
  width: 100%;

  iframe {
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`

const Player = ({ src, embed }) => (
  <Wrapper>
    {src && (
      <>
        <LazyLoad offset={150} once>
          <iframe
            width="960"
            height="540"
            src={src}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Player"
          />
        </LazyLoad>
        <noscript
          dangerouslySetInnerHTML={{
            __html: `<iframe
                width="960"
                height="540"
                src=${src}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Player"
              />`,
          }}
        />
      </>
    )}
    {embed && (
      <LazyLoad offset={150} once>
        <div
          dangerouslySetInnerHTML={{
            __html: embed,
          }}
        ></div>
      </LazyLoad>
    )}
  </Wrapper>
)

export default Player
